import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartToolbarComponent } from './smart-toolbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddStaffDialogModule } from '../add-staff-dialog/add-staff-dialog.module';



@NgModule({
  declarations: [SmartToolbarComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSidenavModule,
    SharedModule,
    AddStaffDialogModule
  ],
  exports: [SmartToolbarComponent]
})
export class SmartToolbarModule { }
